import { ValueOf } from '../utilities/types';
import resourceTypes from './resourceTypes';

const authenticatorTypes = {
  MEMBER: resourceTypes.MEMBER,
  API_KEY: resourceTypes.API_KEY,
  SERVICE: resourceTypes.SERVICE,
} as const;

export type AuthenticatorTypes = ValueOf<typeof authenticatorTypes>;

export default authenticatorTypes;
